import React from 'react';
import styles from './styles.module.css';

import PillButton from '../../../pill-button';
import TickIcon from '../../../../icons/Tick';

export default ({ closeForm }) => (
  <div id="form-submission-successful" className={styles.container}>
    <TickIcon size={96} color="#56ad65" />
    <p>Your submission was successful</p>
    <p>
      We will need to review your submission before it can be published to the
      site.
    </p>
    <PillButton theme="blue" text="Finish" onClick={closeForm} />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/contribution-form/state-pages/submission-successful/index.js